import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './tufts-alert-banner.css.lit';
import '../tufts-container/tufts-container';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import '../../base/outline-icon/outline-icon';
import '../tufts-icon/tufts-icon';

/**
 * The Tufts Alert Banner
 * @extends OutlineElement
 *
 * @slot icon
 * @slot heading
 * @slot text-link
 * @slot close-button
 * @slot pediatric-banner
 */

@customElement('tufts-alert-banner')
export class tuftsAlertBanner extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, tuftsHeadingCssLit];
  ngSlot = new SlotNGController(this);

  @property({ type: String, attribute: 'component-width', reflect: true })
  componentWidth = '100%';
  @property({ type: String, attribute: 'component-margin-top', reflect: true })
  marginTop = '4rem';
  @property({ type: Boolean, attribute: 'alert', reflect: true })
  alert = false;
  @property({ type: Boolean, attribute: 'dismissible', reflect: true })
  dismissible = false;

  iconType(): TemplateResult {
    const iconName = this.alert ? 'alert' : 'information';
    return html`
      <tufts-icon class="icon" library="system" name=${iconName} size="1.5rem">
      </tufts-icon>
    `;
  }

  render(): TemplateResult {
    this.style.setProperty('--component-width', this.componentWidth);
    this.style.setProperty(
      '--component-color',
      this.alert ? 'var(--red-700)' : 'var(--dark-green)'
    );
    this.style.setProperty('--component-margin-top', this.marginTop);
    return html`
      <div class="wrapper">
        ${this.iconType()}
        <div class="content-wrapper">
          ${this.ngSlot.conditionalNGSlot('heading', true, 'sm')}
          ${this.ngSlot.conditionalNGSlot('text-link')}
          ${this.ngSlot.conditionalNGSlot('pediatric-banner')}
        </div>
        ${this.dismissible
          ? html`<div class="close-button-wrapper">
              <slot name="close-button"></slot>
            </div>`
          : ''}
      </div>
    `;
  }
}
